<!--
 * @Description: 
 * @version: 
 * @Author: 李云飞
 * @Date: 2023-07-13 16:18:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-02-05 13:35:33
-->
<template>
  <a-config-provider :locale="locale"
                     :theme="theme">
    <RouterView />
    <GlobalLoading />
  </a-config-provider>
</template>

<script setup>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { theme } from './theme/theme.js';
import GlobalLoading from '@/components/GlobalLoading/index.vue';

dayjs.locale('zh-cn');

const locale = zhCN;
</script>

<style lang="less">
.ant-form-inline {
  margin-bottom: 20px;
}
</style>
